/* eslint-disable no-undef */
import Vue from 'vue';

let decode = require('jwt-decode');

const SET_TOKEN = 'set_token';

const LOGIN = 'login';
const LOGIN_REQUEST = 'login_request';
const LOGIN_SUCCESS = 'login_success';
const LOGIN_ERROR = 'login_error';

const LOGOUT = 'logout';
const LOGOUT_REQUEST = 'logout_request';
const LOGOUT_SUCCESS = 'logout_success';
const LOGOUT_ERROR = 'logout_error';

const UNAUTHORIZED = 'unauthorized';

const RENEW = 'renew';
const RENEW_REQUEST = 'renew_request';
const RENEW_SUCCESS = 'renew_success';
const RENEW_ERROR = 'renew_error';

const USER_PROFILE = 'user_profile';
const PROFILE_REQUEST = 'profile_request';
const SET_PROFILE = 'set_profile';
const PROFILE_SUCCESS = 'profile_success';
const PROFILE_ERROR = 'profile_error';

export { LOGIN, LOGOUT, UNAUTHORIZED, RENEW, USER_PROFILE };

export default {
    state: {
        token: localStorage.getItem('token'),
        loading: false,
        errors: [],
        userId: undefined,
        profile: {}
    },
    mutations: {
        [SET_TOKEN] (state, result) {
            const token = result.token;
            const userId = result.id;
            state.token = token;
            state.userId = userId;
            if (token) {
                localStorage.setItem('token', token);
            } else {
                localStorage.removeItem('token');
            }
        },
        [SET_PROFILE] (state, profile) {
            state.profile = profile;
        },

        [LOGIN_REQUEST] (state) {
            state.loading = true;
            state.errors = [];
        },
        [LOGIN_SUCCESS] (state) {
            state.loading = false;
        },
        [LOGIN_ERROR] (state, errors) {
            state.loading = false;
            state.errors = errors;
        },

        [LOGOUT_REQUEST] (state) {
            state.loading = true;
            state.errors = [];
        },
        [LOGOUT_SUCCESS] (state) {
            state.loading = false;
        },
        [LOGOUT_ERROR] (state, errors) {
            state.loading = false;
            state.errors = errors;
        },

        [RENEW_REQUEST] (state) {
            state.loading = true;
            state.errors = [];
        },
        [RENEW_SUCCESS] (state) {
            state.loading = false;
        },
        [RENEW_ERROR] (state, errors) {
            state.loading = false;
            state.errors = errors;
        },

        [PROFILE_REQUEST] (state) {
            state.loading = true;
            state.errors = [];
        },
        [PROFILE_SUCCESS] (state) {
            state.loading = false;
        },
        [PROFILE_ERROR] (state, errors) {
            state.loading = false;
            state.errors = errors;
        }
    },
    actions: {
        // Sign a user in
        [LOGIN] ({ commit, dispatch }, { username, password, role }) {
            commit(LOGIN_REQUEST);

            return Vue.axios.post('auth/login', {
                email: username,
                password: password,
                role: role
            })
                .then(resp => {
                    commit(SET_TOKEN, resp.data);
                    commit(LOGIN_SUCCESS);
                    dispatch(USER_PROFILE);
                }).catch(({status, errors}) => {
                    // Failure
                    commit(LOGIN_ERROR, errors);
                    throw { status, errors };
                });
        },

        // Sign a user out
        [LOGOUT]: ({ commit, state }) => {
            commit(LOGOUT_REQUEST);

            return Vue.axios.post('auth/logout')
                .then(() => {
                    commit(SET_TOKEN, { token: null, userId: undefined });
                    commit(LOGOUT_SUCCESS);
                }).catch(({status, errors}) => {
                    commit(LOGIN_ERROR, errors);
                    throw { status, errors };
                });
        },

        [UNAUTHORIZED]: ({ commit, state }) => {
            commit(LOGOUT_REQUEST);
            commit(SET_TOKEN, { token: null, userId: undefined });
            commit(LOGOUT_SUCCESS);
        },

        // Renew token
        [RENEW]: ({ commit, state }) => {
            commit(RENEW_REQUEST);

            return Vue.axios.post('auth/refresh')
                .then(resp => {
                    commit(SET_TOKEN, resp.data);
                    commit(RENEW_SUCCESS);
                }).catch(({status, errors}) => {
                    commit(RENEW_ERROR, errors);
                    throw { status, errors };
                });
        },

        // Get logged in user's profile
        [USER_PROFILE]: ({ commit, state }) => {
            commit(PROFILE_REQUEST);

            if (!state.userId) {
                state.userId = decode(state.token).id;
            }

            return Vue.axios.get(`account/${state.userId}`)
                .then(resp => {
                    commit(SET_PROFILE, resp.data);
                    commit(PROFILE_SUCCESS);
                }).catch(({status, errors}) => {
                    commit(PROFILE_ERROR, errors);
                    throw { status, errors };
                });
        }
    },
    getters: {
        decodedToken: state => {
            return state.token != null ? decode(state.token) : null;
        },
        isTokenExpired: (state, getters) => {
            let decoded = getters.decodedToken;
            if (!decoded)
                return true;
            return (decoded.exp * 1000) < new Date().getTime();
        },
        isAuthenticated: (state, getters) => {
            return state.token != null && !getters.isTokenExpired;
        },
        currentUser: (state, getters) => {
            let decoded = getters.decodedToken;
            return {
                firstName: decoded != null ? decoded.first_name : null,
                lastName: decoded != null ? decoded.last_name : null,
                id: decoded != null ? decoded.id : null
            };
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js